import PropTypes from 'prop-types';
import React from 'react';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import SVGFromCloudinary from '../../Elements/SVGFromCloudinary/SVGFromCloudinary';
import GroupBanner from '../../Icons/Messages/GroupBanner';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import { messageTypes } from '../../Includes/variables';

import './EmptyMessages.scss';
import { PAGE_DISPLAY_MODE } from '../../../pages/constants';

export default class EmptyMessages extends React.PureComponent {
    static propTypes = {
        /**
         * css class that would override component's styling
         */
        className: PropTypes.string.isRequired,
        messageType: PropTypes.string.isRequired,
        pageDisplayMode: PropTypes.string.isRequired,
    };

    static defaultProps = {
        className: '',
    };

    handleClick = () => {
        EmitMetric({
            misc_event_type: 'messaging-middle-rail-group-zero-state-click',
            misc_event_count: 1,
        });
    };

    renderEmptyGroup = () => {
        const exploreHref = '/groups';
        return (
            <div className={'component-Messages-EmptyMessages__group-content'}>
                <div className="logo-banner">{GroupBanner}</div>
                <div className="intro-msg">
                    Discover and join groups with like-minded women who share
                    your skills and interests.
                </div>
                <a className="explore-btn" href={exploreHref}>
                    Explore
                </a>
            </div>
        );
    };

    renderEmptyEmployer = () => {
        const employerText = (
            <div className="intro-msg">
                <p>
                    Access private professional profiles and send direct
                    messages to FGB members who meet your hiring needs.
                </p>
            </div>
        );

        const candidateText = (
            <div className="intro-msg">
                <p>
                    Connect with recruiters. Message recruiters directly when
                    you apply to select roles.
                </p>
                <p>
                    Search these{' '}
                    <a
                        href={'/jobs/find?filters_quick_apply=1'}
                        title={'Search all quick apply jobs'}
                        onClick={this.handleClick}
                        className="highlight"
                    >
                        quick apply jobs
                    </a>{' '}
                    now.
                </p>
            </div>
        );
        return (
            <div
                className={'component-Messages-EmptyMessages__employer-content'}
            >
                {this.props.pageDisplayMode ===
                PAGE_DISPLAY_MODE.EMPLOYER_DEFAULT
                    ? employerText
                    : candidateText}
                <div className="component-Messages-EmptyMessages__employer-background">
                    <SVGFromCloudinary
                        cloudinaryID={'/v1583979180/SVGs/plant.svg'}
                        alt={''}
                        className={
                            'component-Messages-EmptyMessages__employer-background-plant'
                        }
                    />
                </div>
            </div>
        );
    };

    renderEmptyContent = () => {
        switch (this.props.messageType) {
            case messageTypes.GROUP:
                return this.renderEmptyGroup();
            case messageTypes.EMPLOYER:
                return this.renderEmptyEmployer();
            default:
                return <span />;
        }
    };

    render() {
        const { className } = this.props;

        return (
            <div className={`component-Messages-EmptyMessages ${className}`}>
                <CommonCardShell className="card-shell">
                    {this.renderEmptyContent()}
                </CommonCardShell>
            </div>
        );
    }
}
